import { CategoryTag } from '@catalog/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CatalogState, CategoryTagsState, StateWithCatalog } from '../catalog-state';
import { getCustomCatalogState } from './feature.selector';

export const getCategoryTagsState: MemoizedSelector<StateWithCatalog, CategoryTagsState> = createSelector(
  getCustomCatalogState,
  (state: CatalogState) => state.categoryTags,
);

export const getCategoryTags = (
  uid: string,
): MemoizedSelector<StateWithCatalog, StateUtils.LoaderState<CategoryTag[]>> =>
  createSelector(getCategoryTagsState, (state: CategoryTagsState) =>
    StateUtils.entityLoaderStateSelector<CategoryTag[]>(state.items, uid),
  );

export const getCategoryTagsValue = (uid: string): MemoizedSelector<StateWithCatalog, CategoryTag[]> =>
  createSelector(getCategoryTagsState, (state: CategoryTagsState) =>
    StateUtils.entityValueSelector<CategoryTag[]>(state.items, uid),
  );

export const getCategoryTagsLoading = (uid: string): MemoizedSelector<StateWithCatalog, boolean> =>
  createSelector(getCategoryTagsState, (state: CategoryTagsState) =>
    StateUtils.entityLoadingSelector<CategoryTag[]>(state.items, uid),
  );

export const getCategoryTagsError = (uid: string): MemoizedSelector<StateWithCatalog, boolean> =>
  createSelector(getCategoryTagsState, (state: CategoryTagsState) =>
    StateUtils.entityErrorSelector<CategoryTag[]>(state.items, uid),
  );

export const getCategoryTagsSuccess = (uid: string): MemoizedSelector<StateWithCatalog, boolean> =>
  createSelector(getCategoryTagsState, (state: CategoryTagsState) =>
    StateUtils.entitySuccessSelector<CategoryTag[]>(state.items, uid),
  );

export const getActiveCategoryTagValue = (): MemoizedSelector<StateWithCatalog, CategoryTag> =>
  createSelector(getCategoryTagsState, (state: CategoryTagsState) =>
    StateUtils.loaderValueSelector<CategoryTag>(state.activeItem),
  );
